module.exports = __webpack_public_path__ + "static/media/corceptual-systems-cbs.74700db6.jpg";